module.exports = __webpack_public_path__ + "static/media/vertical_com_fotos.7d89badb.png";